var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'toast toast-' + _vm.data.type,staticStyle:{"display":"block"},on:{"click":_vm.click,"mouseover":_vm.onMouseOver,"mouseout":_vm.onMouseOut}},[_c('div',{staticClass:"toast-title",domProps:{"innerHTML":_vm._s(_vm.data.title)}}),_vm._v(" "),_c('div',{staticClass:"toast-message",domProps:{"innerHTML":_vm._s(_vm.data.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }